module.exports = __webpack_public_path__ + "img/xw3.35f577ff.png";